import React from 'react';
import Spinner from 'react-spinner';

import fetchContent from '../../../helpers/backend-communication';

import CountryProfileModal from './Modal';
import CountryProfileReportList from './ItemReportList';
import NationalContactsContentList from '../../NationalContacts/NationalContactsContentList';

function sortReportsByMostRecent(reportList) {
  return reportList.sort(function(itemA, itemB) {
    const yearA = itemA.attributes.reportingYear,
      yearB = itemB.attributes.reportingYear;

    if (yearA < yearB) {
      return 1;
    } else if (yearA > yearB) {
      return -1;
    }

    return 0;
  });
}

class CountryProfileMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reports: [],
      npc: null,
      isLoadingReports: false,
      isLoadingNPC: false
    };
  }

  componentDidMount() {
    console.log('Fetching report list for country profile....');

    this.getReportList();
    this.getNPC();
  }

  getReportList() {
    this.setState({
      isLoadingReports: true,
      isLoadingNPC: true
    });

    fetchContent('reports', `?country__iso_alpha_3=${ this.props.countryCode }`)
      .then(responseObject => {
        const reportList = responseObject.data;
        sortReportsByMostRecent(reportList);

        this.setState({
          reports: reportList,
          isLoadingReports: false
        });
      })
      .catch(error => {
        this.setState({
          reports: [],
          isLoadingReports: false
        });
        console.error('Fetch report list went wrong', error);
      });
  }

  getNPC() {
    console.log('Fetching npc for country profile....');

    fetchContent('npcComplete', `?country=${ this.props.countryCode }`)
      .then(responseObject => {
        this.setState({
          npc: responseObject,
          isLoadingNPC: false
        });
      })
      .catch(error => {
        this.setState({
          npc: null,
          isLoadingNPC: false
        });
        console.error('Fetch npc went wrong', error);
      });
  }

  renderNPC() {
    if (this.state.isLoadingNPC) return <Spinner className="national-contacts__spinner" />;

    return (
      <NationalContactsContentList
        className='country-profile-menu__item-npc'
        data={ this.state.npc }
      />
    );
  }

  renderReportList() {
    return (
      <CountryProfileReportList
        reports={ this.state.reports }
        isLoading={ this.state.isLoadingReports }
      />
    );
  }

  renderLastReport() {
    const report = this.state.reports[0];

    return (
     <span>
        Last report:&nbsp;
        <a target="_blank" className="country-profile-menu__button"
          href={ report && report.links.reportFile }
        >
          { report ? report.attributes.reportingYear : '----' }
        </a>
      </span>
    );
  }

  render() {
    const NPCFormatted = this.renderNPC();
    const reportListFormatted = this.renderReportList();

    return (
      <div className="country-profile-menu">
        { this.renderLastReport() }

         <CountryProfileModal
          title={"Submitted reports of " + this.props.countryName}
          content={reportListFormatted}
        >
          <span className="country-profile-menu__icon glyphicon glyphicon-list-alt"></span>
          <span className="country-profile-menu__button"> All reports</span>
        </CountryProfileModal>

        <CountryProfileModal
          title={"National point of contact of " + this.props.countryName}
          content={NPCFormatted}
        >
          <span className="country-profile-menu__icon glyphicon glyphicon-home"></span>
          <span className="country-profile-menu__button">NPC</span>
        </CountryProfileModal>
      </div>
    );
  }
}

export default CountryProfileMenu;



// WEBPACK FOOTER //
// ./src/components/CountryProfile/Menu/index.js